export enum OperationStatus {
  NotStarted = 'not-started',
  Ongoing = 'ongoing',
  Completed = 'completed',
  SkippedByUser = 'skipped-by-user',
  Paused = 'paused',
  Parked = 'parked',
  Cancelled = 'cancelled',
}

/**
 * The subset of {@link OperationStatus} values that represent an activity
 * which is neither skipped nor cancelled — i.e. one that should appear in
 * the active activities list.
 */
export type ActiveOperationStatus = Exclude<
  OperationStatus,
  OperationStatus.SkippedByUser | OperationStatus.Cancelled
>;

/**
 * The subset of {@link OperationStatus} values that represent an activity
 * which has been skipped or cancelled — i.e. one that should appear in
 * the skipped activities list.
 */
export type SkippedOrCancelledOperationStatus =
  | OperationStatus.SkippedByUser
  | OperationStatus.Cancelled;
